import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Spinner from "../../../Layouts/Spinner";
import axios from "axios";
import ReactSelect from "react-select";
import { addSizeValidation } from "../../../Constant/constant";
import UploadImage from "../../Category/UploadImage";
import { getSingleOccassion, updateOneOccassion } from "../../../../redux/occassion/action";
import FileUpload from "../../../Common/ImageUpload/imageUpload";
import { handleImageUpload } from "../../../Common/ImageUpload/handleImageUpload";
import axiosInstance from "../../../../redux/api";
import { usePermissions } from "../../../../Hooks/usePermissions";
import { MENU, PERMISSION } from "../../../../lib/permissions";

const UpdateOccassion = () => {
  const { id } = useParams();
  const getLocalToken = localStorage.getItem("authcheck")
  const [loading, setLoading] = useState(false);
  const [profileLoader, setProfileLoader] = useState(false);
  const [selectStatus, setSelectStatus] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { hasAction } = usePermissions();
  const [update, setUpdate] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedFile1, setSelectedFile1] = useState(null);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [occasionOptions, setOccasionOptions] = useState([]);
  const [brandOptions, setBrandOptions] = useState([]);
  const singleOccassion = useSelector((state) => state.reusableSlice.singleOccassion);
  console.log(singleOccassion, "singleOccassion")

  const prop = { title: " Image", name: "image" };
  const prop1 = { title: " ar_Image", name: "ar_image" };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      status: singleOccassion.status | 1,
      name: singleOccassion.name || "",
      ar_name: singleOccassion.ar_name || "",
      image: singleOccassion.image || "",
      ar_image: singleOccassion.ar_image || "",
      meta_h1_tag: singleOccassion.meta_h1_tag || "",
      meta_h2_tag: singleOccassion.meta_h2_tag || "",
      page_title: singleOccassion.page_title || "",
      meta_title: singleOccassion.meta_title || "",
      home_view: singleOccassion.home_view || false,
      position: singleOccassion.position || 1,
      meta_description: singleOccassion.meta_description || "",
      banner_image: singleOccassion.banner_image || "",
      ar_banner_image: singleOccassion.ar_banner_image || "",
      banner_type: singleOccassion.banner_type || null,
      banner_master_id: singleOccassion.banner_master_id || "",
    },
    validationSchema: addSizeValidation,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  const handleUploadImage = (e, name) => {
    const file = e.target.files[0];
    setProfileLoader(true);
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const imgData = {
          file: reader.result,
        };
        const token = getLocalToken
        axios
          .post(`${process.env.REACT_APP_API_ENDPOINT}/auth/image-upload`, imgData, {
            headers: {
              "Content-Type": "application/json",
              "auth-token": token,
            },
          })
          .then((response) => {
            if (response.data.status) {
              setProfileLoader(false);
              formik.setFieldValue(name, response.data.response.url);
            }
          })
          .catch((e) => {
            console.log(e.message, "img error");
            setProfileLoader(false);
          });
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (values) => {
    const data = {
      ...values,
      id: singleOccassion.id,
      image: formik.values.image,
       ar_image: formik.values.ar_image,
      banner_image: formik.values.banner_image,
      ar_banner_image: formik.values.ar_banner_image,
      banner_type: formik.values.banner_type,
      banner_master_id: formik.values.banner_master_id,
    };
    dispatch(updateOneOccassion(data, setLoading, navigate));
  };

  const handleChangeStatus = (e) => {
    const gender = e.target.value;
    setSelectStatus(gender);
    formik.setFieldValue("status", Number(gender));
  };

  useEffect(() => {
    if (id) {
      dispatch(getSingleOccassion(id));
    }
  }, [dispatch, id]);

  const positionOptions = Array.from({ length: 50 }, (_, i) => ({
    value: i + 1,
    label: (i + 1).toString(),
  }));

  const showInHomeOptions = [
    { value: true, label: ("Yes") },
    { value: false, label: ("No") },
  ];



  const isEditable = hasAction(MENU.CATALOGUE, PERMISSION.EDIT);


   useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        const [catRes, occRes, brandRes] = await Promise.all([
          axiosInstance.post("/category/get_all", { page: "" }),
          axiosInstance.post("/occasion/get_all", { page: "" }),
          axiosInstance.post("/brand/get_all", { page: "" }),
        ]);

        setCategoryOptions(
          catRes.data?.response?.map((item) => ({
            value: item.id,
            label: item.title,
          })) || []
        );

        setOccasionOptions(
          occRes.data?.response?.map((item) => ({
            value: item.id,
            label: item.name,
          })) || []
        );

        setBrandOptions(
          brandRes.data?.response?.map((item) => ({
            value: item.id,
            label: item.name,
          })) || []
        );
      } catch (err) {
        console.error("Error fetching dropdown data:", err);
      }
    };

    fetchDropdownData();
  }, []);

    const bannerTypeOptions = [
    { value: 1, label: "Category" },
    { value: 2, label: "Occasion" },
    { value: 3, label: "Brand" },
  ];

  const getMasterOptions = () => {
    if (formik.values.banner_type === 1) return categoryOptions;
    if (formik.values.banner_type === 2) return occasionOptions;
    if (formik.values.banner_type === 3) return brandOptions;
    return [];
  };

  console.log(formik.values, "sdfsfsfsdfsdfds")
  return (
    <div className=" card-head order-card order-timing ">
      <div className="sub-head">
        <h4>Update Occassion</h4>
      </div>
      <form onSubmit={formik.handleSubmit}>
        <div className="row ">

          <div className="col-md-3 ">
            <div style={{ position: 'sticky', top: '0' }} className="add-category-row d-flex flex-column">
              <div className="add-category-wrapper ">
                <div className="addcategory-padding">
                  <label htmlFor="status">Status</label>
                  <select
                    disabled={!isEditable}
                    id="status"
                    title="status"
                    className="form-control"
                    onChange={handleChangeStatus}
                    onBlur={formik.handleBlur}
                    value={formik.values.status}
                  >
                    <option value="">Select Status</option>
                    <option value="1">Active</option>
                    <option value="2">Inactive</option>
                  </select>
                  {formik.touched.status && formik.errors.status ? (
                    <div className="error">{formik.errors.status}</div>
                  ) : null}
                </div>
              </div>
              <div className="add-category-wrapper ">
                <div className="addcategory-padding">
                  <label>Position</label>
                  <ReactSelect
                    isDisabled={!isEditable}
                    value={positionOptions.find(
                      (option) => option.value == formik.values?.position
                    )}
                    placeholder={("Position")}
                    id="position"
                    name="position"
                    options={positionOptions}
                    onChange={(option) => {
                      formik.setFieldValue("position", option?.value);
                    }}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.position && formik.errors.position && (
                    <div className="error">{(formik.errors.position)}</div>
                  )}
                </div>
              </div>
              <div className="add-category-wrapper ">
                <div className="addcategory-padding">
                  <label>Show in Home</label>
                  <ReactSelect
                    isDisabled={!isEditable}
                    value={showInHomeOptions.find(
                      (option) => option.value == formik.values?.home_view
                    )}
                    placeholder={("Show in Home")}
                    id="home_view"
                    name="home_view"
                    options={showInHomeOptions}
                    onChange={(option) => {
                      formik.setFieldValue("home_view", option?.value);
                    }}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.home_view && formik.errors.home_view && (
                    <div className="error">{(formik.errors.home_view)}</div>
                  )}
                </div>
              </div>
            </div>

          </div>


          <div className="col-md-9">
            <div className=" product-row row">
              <div className="col-md-12">
                <div className=" add-category-wrapper" >
                  <div className="add-cat-head">
                    <h4>Basic Info</h4>
                  </div>
                  <div className="addcategory-padding">
                    <div className="row ">
                      <div className="col-md-6 form-group">
                        <label>Name</label>
                        <input
                          disabled={!isEditable}
                          type="text"
                          className="form-control"
                          placeholder="Enter name"
                          name="name"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.name}
                        />
                        {formik.touched.name && formik.errors.name ? (
                          <div className="error">{formik.errors.name}</div>
                        ) : null}
                      </div>
                      <div className="col-md-6 form-group">
                        <label>Ar Name</label>
                        <input
                          disabled={!isEditable}
                          type="text"
                          className="form-control"
                          placeholder="Enter ar name"
                          name="ar_name"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.ar_name}
                        />
                        {formik.touched.ar_name && formik.errors.ar_name ? (
                          <div className="error">{formik.errors.ar_name}</div>
                        ) : null}
                      </div>

                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-12">
                <div className=" add-category-wrapper w-100 my-3" >
                  <div className="add-cat-head">
                    <h4>Image Upload</h4>
                  </div>
                  <div className="addcategory-padding">
                    <FileUpload
                      files={selectedFile}
                      setFiles={setSelectedFile}
                      formik={formik}
                      // maxWidth={368}
                      prop={{
                        title: "",
                        name: "image",
                      }}
                      isEditable={isEditable}
                      onFileSelect={async (e) => {
                        if (!isEditable) return;
                        try {
                          const file = e.target.files[0];
                          if (!file) return;

                          await handleImageUpload(
                            file,
                            { title: "images", name: "image" },
                            "image",
                            formik,
                            // 368,
                            // 156
                          );
                          setSelectedFile(file);
                        } catch (error) {
                          console.error(error);
                        }

                      }}
                    />

                  </div>
                </div>
              </div>
               <div className="col-md-12">
                <div className=" add-category-wrapper w-100 my-3">
                  <div className="add-cat-head">
                    <h4>Banner Info</h4>
                  </div>
                  <div className="addcategory-padding">
                    <div className="row">
                      {/* banner image */}
                      <div className="col-md-6">
                        <FileUpload
                          files={selectedFile1}
                          setFiles={setSelectedFile1}
                          formik={formik}
                          prop={{
                            title: "Banner Image",
                            name: "banner_image",
                          }}
                          isEditable={isEditable}
                          onFileSelect={async (e) => {
                            if (!isEditable) return;
                            try {
                              const file = e.target.files[0];
                              if (!file) return;
                              await handleImageUpload(
                                file,
                                { title: "banner_image", name: "banner_image" },
                                "banner_image",
                                formik
                              );
                              setSelectedFile1(file);
                            } catch (error) {
                              console.error(error);
                            }
                          }}
                        />
                      </div>

                      {/* ar banner image */}
                      <div className="col-md-6">
                        <FileUpload
                          files={selectedFile1}
                          setFiles={setSelectedFile1}
                          formik={formik}
                          prop={{
                            title: "AR Banner Image",
                            name: "ar_banner_image",
                          }}
                          isEditable={isEditable}
                          onFileSelect={async (e) => {
                            if (!isEditable) return;
                            try {
                              const file = e.target.files[0];
                              if (!file) return;
                              await handleImageUpload(
                                file,
                                {
                                  title: "ar_banner_image",
                                  name: "ar_banner_image",
                                },
                                "ar_banner_image",
                                formik
                              );
                              setSelectedFile1(file);
                            } catch (error) {
                              console.error(error);
                            }
                          }}
                        />
                      </div>

                      {/* banner type dropdown */}
                      <div className="col-md-6 form-group mt-3">
                        <label>Banner Type</label>
                        <ReactSelect
                          isDisabled={!isEditable}
                          value={bannerTypeOptions.find(
                            (opt) => opt.value === formik.values.banner_type
                          )}
                          options={bannerTypeOptions}
                          onChange={(option) => {
                            formik.setFieldValue("banner_type", option.value);
                            formik.setFieldValue("banner_master_id", "");
                          }}
                        />
                      </div>

                      {/* banner master id dropdown */}
                      <div className="col-md-6 form-group mt-3">
                        <label>Select Item</label>
                        <ReactSelect
                          value={getMasterOptions().find(
                            (opt) => opt.value === formik.values.banner_master_id
                          )}
                          options={getMasterOptions()}
                          onChange={(option) =>
                            formik.setFieldValue(
                              "banner_master_id",
                              option?.value
                            )
                          }
                           isDisabled={
                              !isEditable || !formik.values.banner_type
                            }
                        />
                      </div>
                    </div>
                    </div>
                    </div>
                </div>
              <div className="col-md-12">
                <div className=" add-category-wrapper" >
                  <div className="add-cat-head">
                    <h4>SEO</h4>
                  </div>
                  <div className="addcategory-padding">
                    <div className="row ">
                      <div className="col-md-6 form-group">
                        <label>Meta title</label>
                        <input
                          disabled={!isEditable}
                          type="text"
                          className="form-control"
                          placeholder="Enter meta title"
                          name="meta_title"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.meta_title}
                        />
                        {formik.touched.meta_title && formik.errors.meta_title ? (
                          <div className="error">{formik.errors.meta_title}</div>
                        ) : null}
                      </div>
                      <div className="col-md-6 form-group">
                        <label>Page title</label>
                        <input
                          disabled={!isEditable}
                          type="text"
                          className="form-control"
                          placeholder="Enter page title"
                          name="page_title"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.page_title}
                        />
                        {formik.touched.page_title && formik.errors.page_title ? (
                          <div className="error">{formik.errors.page_title}</div>
                        ) : null}
                      </div>
                      <div className="col-md-6 form-group">
                        <label>meta_h1_tag</label>
                        <input
                          disabled={!isEditable}
                          type="text"
                          className="form-control"
                          placeholder="Enter meta_h1_tag"
                          name="meta_h1_tag"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.meta_h1_tag}
                        />
                        {formik.touched.name && formik.errors.meta_h1_tag ? (
                          <div className="error">{formik.errors.name}</div>
                        ) : null}
                      </div>
                      <div className="col-md-6 form-group">
                        <label>meta_h2_tag</label>
                        <input
                          disabled={!isEditable}
                          type="text"
                          className="form-control"
                          placeholder="Enter meta h2 tag"
                          name="meta_h2_tag"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.meta_h2_tag}
                        />
                        {formik.touched.meta_h2_tag && formik.errors.meta_h2_tag ? (
                          <div className="error">{formik.errors.meta_h2_tag}</div>
                        ) : null}
                      </div>
                      <div className="col-12 form-group">
                        <label>Meta Description</label>
                        <textarea
                          disabled={!isEditable}
                          className="form-control"
                          class="form-control"
                          aria-label="With textarea"
                          value={formik.values?.meta_description}
                          placeholder="Meta Description"
                          id="meta_description"
                          name="meta_description"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          touched={formik.touched}
                          errors={formik.errors}
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="d-flex align-items-center justify-content-between back-update "
                style={{ columnGap: "20px" }}
              >
                <button
                  className="back-btn  "
                  onClick={() => {
                    navigate("/occassion");
                  }}
                  style={{ width: "max-content" }}
                >
                  Back
                </button>
                {isEditable && (
                  <button
                    className="submit-btn"
                    disabled={loading}
                    type="submit"
                  >
                    {!loading ? "Submit" : <Spinner />}
                  </button>
                )}
              </div>
            </div>









          </div>
        </div>

      </form>
    </div>
  );
};

export default UpdateOccassion;
